import React from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';

import MetaTags from 'Components/MetaTags/MetaTags';
import PageComposer from 'Components/PageComposer/PageComposer';
import texts from 'Components/texts.json';
import proPropTypes from 'Utilities/proPropTypes';

T.setTexts(texts);

const PageBase = ({
	children,
	description,
	fixedBottomBarClassName,
	noIndex = true,
	pageSlug,
	showFixedBottomBar,
	showSitewideFooter = true,
	title,
}) => (
	<>
		<MetaTags description={T.translate(description)} noIndex={noIndex} title={T.translate(title)} />
		<PageComposer
			fixedBottomBarClassName={fixedBottomBarClassName}
			pageSlug={pageSlug}
			showFixedBottomBar={showFixedBottomBar}
			showSitewideFooter={showSitewideFooter}
		>
			{children}
		</PageComposer>
	</>
);

PageBase.propTypes = {
	children: PropTypes.node.isRequired,
	description: PropTypes.string.isRequired,
	fixedBottomBarClassName: proPropTypes.className,
	noIndex: PropTypes.bool,
	pageSlug: PropTypes.string,
	showFixedBottomBar: PropTypes.bool,
	showSitewideFooter: PropTypes.bool,
	title: PropTypes.string.isRequired,
};

export default PageBase;
